module.exports = __webpack_public_path__ + "img/black_pawn.41d82a94.png";